module.exports = __webpack_public_path__ + "img/icon-tip.205b5ddb.svg";